module.exports = __webpack_public_path__ + "static/img/slider-bg.0f66fdf.jpg";